import { Teaser } from './Teaser'

export default Teaser
